export default "__VITE_ASSET__Dtvl42gH__"